export default __webpack_public_path__ + "static/beefy-hero-1be8f96372f567fccef867bade73bc4c.svg";